export default "__VITE_ASSET__CQOLqFQ8__"